var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4rem",
    height: "4rem",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,6.25L6,6.25C4.491,6.25 3.25,7.491 3.25,9L3.25,18C3.25,19.509 4.491,20.75 6,20.75L15,20.75C16.509,20.75 17.75,19.509 17.75,18C17.75,18 17.75,13 17.75,13C17.75,12.586 17.414,12.25 17,12.25C16.586,12.25 16.25,12.586 16.25,13L16.25,18C16.25,18.686 15.686,19.25 15,19.25C15,19.25 6,19.25 6,19.25C5.314,19.25 4.75,18.686 4.75,18C4.75,18 4.75,9 4.75,9C4.75,8.314 5.314,7.75 6,7.75C6,7.75 11,7.75 11,7.75C11.414,7.75 11.75,7.414 11.75,7C11.75,6.586 11.414,6.25 11,6.25ZM18.189,4.75L9.47,13.47C9.177,13.762 9.177,14.238 9.47,14.53C9.762,14.823 10.238,14.823 10.53,14.53L19.25,5.811L19.25,9C19.25,9.414 19.586,9.75 20,9.75C20.414,9.75 20.75,9.414 20.75,9L20.75,4C20.75,3.872 20.718,3.752 20.661,3.646C20.634,3.596 20.601,3.547 20.561,3.503L20.543,3.483L20.53,3.47L20.509,3.45L20.497,3.439C20.453,3.399 20.405,3.366 20.354,3.339C20.248,3.282 20.128,3.25 20,3.25L15,3.25C14.586,3.25 14.25,3.586 14.25,4C14.25,4.414 14.586,4.75 15,4.75L18.189,4.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.0eb880ce.svg";
export { ForwardRef as ReactComponent };